import { useQuery } from '@tanstack/react-query'

import { ApiService } from '~lib/helpers/api'

export const useSignatureImage = ({
  campaignId,
  distributionId,
  hasSignature,
}: {
  campaignId: string
  distributionId: string
  hasSignature: boolean
}) => {
  const getSignatureImage = async ({
    campaignId,
    distributionId,
  }: {
    campaignId: string
    distributionId: string
  }) => {
    const { data } = await ApiService.post<string>(
      `/campaigns/${campaignId}/distributions/${distributionId}/signature`,
    )
    return data
  }

  const { data, isLoading, error } = useQuery({
    queryKey: ['signature-image', campaignId, distributionId],
    queryFn: () => getSignatureImage({ campaignId, distributionId }),
    enabled: hasSignature,
  })

  return {
    data,
    isLoading,
    error,
  }
}
